module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/recharts/~/core-js/modules/_a-function.js
 ** module id = 1996
 ** module chunks = 3
 **/